import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function that limits the number of digits in a numeric input
 * @param maxDigits - Maximum number of digits allowed (default: 10)
 * @returns ValidatorFn that returns validation error if exceeded
 */
export function maxDigitsValidator(maxDigits: number = 10): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Don't validate empty values
    }

    // Convert to string and remove any formatting (commas, etc.)
    const value = control.value.toString().replace(/[^0-9]/g, '');
    
    if (value.length > maxDigits) {
      return {
        maxDigits: {
          actual: value.length,
          max: maxDigits,
          message: `Maximum ${maxDigits} digits allowed`
        }
      };
    }

    return null;
  };
}

/**
 * Validator function specifically for 10-digit limit
 * @returns ValidatorFn that returns validation error if more than 10 digits
 */
export function max10DigitsValidator(): ValidatorFn {
  return maxDigitsValidator(10);
}
